import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import { getDayPosition } from './getDayPosition';
import { useTimeTracking } from '../../time-tracking/AppTimeProvider';
import SmallProgressBar from '../../special/SmallProgressBar';
import { renderHours } from '../../../scenes/time-tracking/worktime';
import { ProjectUserStack } from '../project/ProjectUserStack';
import DateLabel from '../../label/DateLabel';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { NavLink } from 'react-router-dom';

export const GantWP = ({
  workPackage,
  dayWidth,
  onEdit,
  days,
  inEditMode,
  onChange,
  projectId,
  resolution,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { icon, title, startDate, endDate, users, id } = workPackage;

  const startIndex = startDate
    ? getDayPosition(startDate, days) / resolution
    : 0;
  const endIndex = endDate
    ? (getDayPosition(endDate, days) + 1) / resolution
    : days.length / resolution;

  const offset = 0;

  const { clockIn, clockOut, activeProject, secondsIn } = useTimeTracking();

  const activeWorkpackage =
    activeProject &&
    activeProject.activeWorkPackage &&
    activeProject.activeWorkPackage.id === workPackage.id
      ? {
          ...activeProject.activeWorkPackage,
          totalTimeWorkedSeconds: secondsIn
            ? activeProject.activeWorkPackage.totalTimeWorkedSeconds + secondsIn
            : activeProject.activeWorkPackage.totalTimeWorkedSeconds,
        }
      : null;

  const workPercentage = activeWorkpackage
    ? activeWorkpackage.totalTimeWorkedSeconds / activeWorkpackage.estimatedTime
    : workPackage.totalTimeWorkedSeconds / workPackage.estimatedTime;

  const workedTime =
    (activeWorkpackage
      ? activeWorkpackage.totalTimeWorkedSeconds
      : workPackage.totalTimeWorkedSeconds) / 60;

  return (
    <Box
      onDoubleClick={() => onEdit(workPackage)}
      sx={{
        bgcolor: colors.card,
        boxShadow: `0px 3px 7px rgba(0,0,0,0.2)`,
        marginLeft: `${startIndex * dayWidth + offset}px`,
        maxWidth: `${(endIndex - startIndex) * dayWidth - 2 * offset}px`,
        border: `1px solid transparent`,
        ':hover': {
          bgcolor: colors.info + '30',
          border: `1px solid ${colors.info}80`,
        },
      }}
      className="@container flex items-center gap-2 rounded-lg px-2 py-1 backdrop-blur-md cursor-pointer justify-between"
    >
      <Box className="flex items-center">
        <img
          className="w-[45px] h-[45px] -my-1 -ml-1"
          src={icon?.temporaryUrl}
        />
        <Box>
          <NavLink
            to={`work-package/${id}`}
            className="flex gap-2 items-center"
          >
            <Typography fontWeight={600}>{title}</Typography>

            <IconButton size="small">
              <OpenInNewIcon sx={{ fontSize: '14px' }} />
            </IconButton>
          </NavLink>
          <Typography className=" opacity-60" fontWeight={500}>
            {startDate ? <DateLabel date={startDate} /> : '??'}
            {' - '}
            {endDate ? <DateLabel date={endDate} /> : '??'}
          </Typography>
        </Box>
      </Box>
      <Box
        className=" gap-2 flex"
        sx={{
          '.MuiAvatar-root': {
            width: '30px',
            height: '30px',
          },
        }}
      >
        {Boolean(workPercentage) && (
          <Box className=" items-center gap-2 hidden @sm:flex">
            <SmallProgressBar percent={workPercentage} />
            <Box className="hidden @md:block">
              <Typography fontWeight={600} fontSize={11}>
                {Math.round(workPercentage * 100)}%
              </Typography>
              <Typography fontSize={11} fontWeight={500} className="opacity-50">
                {renderHours(workedTime)}h
                {Boolean(workPackage.estimatedTime) &&
                  ` / ${renderHours(workPackage.estimatedTime / 60)}h`}
              </Typography>
            </Box>
          </Box>
        )}
        <ProjectUserStack
          editmode={inEditMode}
          users={users}
          workPackage={workPackage}
          onChange={onChange}
          projectId={projectId}
          noLabel
          size="20px"
          noEmptyIcon
        />
      </Box>
    </Box>
  );
};
